import { AuthProvider } from 'react-admin';
const API_URL = import.meta.env.VITE_API_URL;

const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    const res = await fetch(`${API_URL}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    if (!res.ok) {
      const { error } = await res.json();
      return Promise.reject(error || 'ra.auth.sign_in_error');
    }

    const user = await res.json();
    localStorage.setItem('username', user.fullName);
    return Promise.resolve();
  },

  logout: () => {
    localStorage.removeItem('username');
    return Promise.resolve();
  },

  checkError: () => Promise.resolve(),

  checkAuth: () =>
    localStorage.getItem('username') ? Promise.resolve() : Promise.reject(),

  getPermissions: () => Promise.resolve(),

  getIdentity: () => {
    const fullName = localStorage.getItem('username');
    return Promise.resolve({
      id: 'user',
      fullName: fullName || 'Admin',
      avatar: '',
    });
  },
};

export default authProvider;
